import { makeStyles } from "@material-ui/core/styles"
import { green } from "@material-ui/core/colors"

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  colorbox: {
    width: "90px",
    height: "52px",
    borderRadius: theme.radius.radius300,
    border: `1px solid ${theme.palette.neutral300}`,
    padding: "10px 16px 10px 16px",
    gap: "10px",
    marginBottom: 24,
  },
  multFieldLine: {
    display: "flex",
    "& > *:not(:last-child)": {
      marginRight: theme.spacing(1),
    },
  },
  btnFullWidth: {
    width: "100%",
    minHeight: "40px",
    borderRadius: "12px",
    fontWeight: 500,
  },
  buttonsContainer: {
    backgroundColor: theme.palette.background100,
    minHeight: "72px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    gap: "8px",
    paddingTop: "16px",
    paddingBottom: "16px",
    paddingLeft: "24px",
    paddingRight: "24px",
  },
  btnWrapper: {
    width: "100%",
    maxWidth: "164px",
    height: "40px",
    borderRadius: "12px",
    fontWeight: 500,
  },

  content: {
    padding: 0,
    overflowY: "hidden",
  },

  colorPicker: {
    backgroundColor: theme.palette.background100,
    padding: 16,
    borderRadius: 12,
    border: `1px solid ${theme.palette.neutral200}`,
    display: "flex",
    flexDirection: "row",
    width: "100%",
    marginTop: 24,
  },

  background: {
    backgroundColor: theme.palette.background100,
  },

  textField: {
    borderRadius: "12px",
    minHeight: "52px",
    justify: "Space-between",
    marginBottom: 24,

    "& .MuiOutlinedInput-root": {
      borderRadius: "12px",
      height: "52px",
    },
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  colorAdorment: {
    width: 20,
    height: 20,
  },
}))

export default useStyles
